import { Check, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToId } from "../constants";

export const ProblemSection = () => (
  <section className="bg-ice/50 py-16 md:py-24" data-testid="problem-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="max-w-3xl">
        <Reveal>
          <p className="text-xs font-semibold tracking-[0.3em] uppercase text-brand mb-5">
            Der Wechsel ist einfach
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-ink">
            Unzufrieden mit Ihrer aktuellen Reinigungsfirma?
          </h2>
          <p className="mt-5 text-base sm:text-lg text-mutedtext leading-relaxed">
            Unzuverlässige Termine, schwankende Reinigungsqualität oder ständig wechselnde
            Ansprechpartner? EMT-Reinigung bietet Unternehmen eine professionelle und
            zuverlässige Alternative.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-8 flex flex-col sm:flex-row sm:items-center gap-5">
            <button
              onClick={() => scrollToId("kontakt")}
              className="inline-flex items-center justify-center gap-2 rounded-full bg-conv hover:bg-conv-dark text-white font-semibold px-7 py-3.5 transition-all duration-200 hover:scale-[1.03]"
              data-testid="problem-cta-wechseln"
            >
              Jetzt unverbindlich wechseln
              <ArrowRight className="w-4 h-4" />
            </button>
            <p className="flex items-center gap-2 text-sm font-medium text-ink/70">
              <Check className="w-4 h-4 text-conv" strokeWidth={3} />
              Kostenlose Objektbesichtigung &amp; individuelles Angebot
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
